"use strict";

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var config = require("config");

(function () {
  angular.module("app").factory("customPlaceSetService", ["$http", "$q", "favoriteLocationsService", "LocationItem", "_", function ($http, $q, favoriteLocationsService, LocationItem, _) {

    // pchen: promise that resolves to
    //   [ <DASet where Places: [ LocationItem instead of DAPlace ]> ]
    // unresolved promise means existing webservice call in-progress, in which case new calls should NOT be started
    var lazyInitdCustomPlaceSets = void 0;
    // used to check whether the data is ready for favorite name validation
    var inProgress = false;

    function loadCustomPlaceData() {
      inProgress = true;
      lazyInitdCustomPlaceSets = $q.all([
      // TODO pchen: have an endpoint specifically to get this data in one call, instead of having two calls
      getDAPlaceSetsWithPlaces({ onlyMine: true, useShared: false }), getDAPlaceSetsWithPlaces({ onlyMine: true, useShared: true })]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            ownerSets = _ref2[0],
            accountSets = _ref2[1];

        return ownerSets.concat(accountSets);
      }).then(function (daPlaceSets) {
        // filter out favorites; they are managed by a different service
        daPlaceSets = favoriteLocationsService.filterOutFavoriteSets(daPlaceSets);
        daPlaceSets.forEach(function (daPlaceSet) {
          daPlaceSet.Places = daPlaceSet.Places.map(function (daPlace) {
            return new LocationItem(daPlace, daPlace.PlaceName);
          });
        });
        return daPlaceSets;
      }).catch(function (err) {
        // pchen: reset state; no longer "in progress"
        // TODO pchen: expose the errors to the user
        lazyInitdCustomPlaceSets = undefined;
      }).finally(function () {
        inProgress = false;
      });

      return lazyInitdCustomPlaceSets;
    }

    function isDataLoaded() {
      return lazyInitdCustomPlaceSets !== undefined && !inProgress;
    }

    function getDAPlaceSetsWithPlaces() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$onlyMine = _ref3.onlyMine,
          onlyMine = _ref3$onlyMine === undefined ? true : _ref3$onlyMine,
          _ref3$useShared = _ref3.useShared,
          useShared = _ref3$useShared === undefined ? false : _ref3$useShared;

      var params = {
        "includePlaces": true,
        onlyMine: onlyMine,
        useShared: useShared,
        "readOnlyPublicData": false
      };

      var request = {
        method: "GET",
        url: config.daUrl + "place-sets/-1",
        params: params
      };

      return $http(request).then(function (_ref4) {
        var placeSetList = _ref4.data;

        return placeSetList;
      });
    }

    function getCustomPlaceSets() {
      if (lazyInitdCustomPlaceSets === undefined) {
        loadCustomPlaceData();
      }
      return lazyInitdCustomPlaceSets;
    }

    return {
      getCustomPlaceSets: getCustomPlaceSets,
      isDataLoaded: isDataLoaded
    };
  }]);
})();


// WEBPACK FOOTER //
// ./app/places/customPlaceSet.service.js